export class ContractCoverageEntity {
  constructor({ name, limit }) {
    this.name = name;
    this.limit = limit;
  }
}
